export default {
  configuration: {
    dialog: {
      header: 'Warning!',
      unnamedClassification: 'unnamed',
      save:
        'Save all data?<br><br>' +
        '<strong>Warning:</strong> classifications are fully rewritten. ' +
        'Any classification you removed from this screen will cease to exist, and the already ' +
        'closed managements that used it lose their link to it, showing up as zeroed. ' +
        'This cannot be undone after saving.',
      undo: 'Undo all unsaved data?',
      restoreDefault:
        'Restore all classifications to the default ones?<br><br>' +
        '<strong>Warning — this action deletes data:</strong> every configured classification ' +
        'and collection is deleted and the default ones are recreated with new identifiers. ' +
        'The already closed managements lose their link to the classifications and show up as ' +
        'zeroed. This cannot be undone.',
      removeClassification:
        'Remove the classification "{name}"?<br><br>' +
        'Once saved, it will cease to exist and the already closed managements that used it lose ' +
        'their link to it, showing up as zeroed.',
    },
  },
};
